import React from 'react';

import { EMAIL_REGEXP } from 'suits-me-npm/constants';
import countries from 'suits-me-npm/constants/countries';
import Field from 'components/shared/form/presentational/Field';
import ModalOuterContainer from '../../generic/containers/ModalOuterContainer';
import Form from 'components/shared/form/presentational/Form';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import Select from 'components/shared/form/presentational/Select';
import TextInput from 'components/shared/form/presentational/TextInput';
import DatePicker from 'components/shared/form/presentational/DatePicker';
import useTranslate from 'suits-me-npm/languages/useTranslate';
import PostCodeAutoComplete from 'components/shared/form/presentational/PostCodeAutoComplete';
import { getCountryCode } from 'utils/generic';

const titleOptions = [
    { label: 'Mr', value: 'Mr' },
    { label: 'Ms', value: 'Ms' },
    { label: 'Miss', value: 'Miss' },
    { label: 'Mrs', value: 'Mrs' },
];

const genderOptions = [
    { label: 'Male', value: 'M' },
    { label: 'Female', value: 'F' },
];

const countryOptions = countries.map(country => ({
    label: country,
    value: country,
}));

const AddCardHolderModal = ({
    handleChange,
    handleSubmit,
    isPosting,
    country,
    ...form
}) => {
    const translate = useTranslate('cards.addCardholderForm');
    return (
        <ModalOuterContainer
            className="add-cardholder-modal"
            handleSubmit={handleSubmit}
            isPosting={isPosting}
        >
            <div className="description">
                <Typography tag="h1">{translate('titleText')}</Typography>
            </div>

            <Form
                onSubmit={handleSubmit}
                omitButtons
                isPosting={isPosting}
                tracking
                trackingLabel="ADD_CARDHOLDER_MODAL_SUBMIT"
            >
                <Field required>
                    <Select
                        placeholder={translate('title')}
                        required
                        name="title"
                        value={form.title}
                        options={titleOptions}
                        onChange={handleChange}
                        classes="generic-input bg"
                    />
                </Field>
                <Field required>
                    <TextInput
                        required
                        name="forename"
                        placeholder={translate('forename')}
                        value={form.forename}
                        onChange={handleChange}
                        classes="generic-input bg"
                    />
                </Field>
                <Field required>
                    <TextInput
                        required
                        name="surname"
                        placeholder={translate('surname')}
                        value={form.surname}
                        onChange={handleChange}
                        classes="generic-input bg"
                    />
                </Field>
                <Field required>
                    <Select
                        required
                        name="gender"
                        placeholder={translate('gender')}
                        value={form.gender}
                        options={genderOptions}
                        onChange={handleChange}
                        classes="generic-input bg"
                    />
                </Field>
                <Field required>
                    <TextInput
                        required
                        name="email"
                        placeholder={translate('email')}
                        value={form.email}
                        onChange={handleChange}
                        classes="generic-input bg"
                        validationRegexp={EMAIL_REGEXP}
                    />
                </Field>
                <Field required>
                    <DatePicker
                        required
                        name="dob"
                        placeholder={translate('dob')}
                        value={form.dob}
                        onChange={handleChange}
                        classes="generic-input bg"
                    />
                </Field>
                <Field name={translate('selectAddress')} required>
                    <PostCodeAutoComplete
                        value={form.postCode}
                        onChange={handleChange}
                        countryCode={getCountryCode(country)}
                        classes="generic-input bg mb"
                    />
                </Field>
                <Field required>
                    <TextInput
                        required
                        name="addressLine1"
                        placeholder={translate('addressLine1')}
                        value={form.addressLine1}
                        onChange={handleChange}
                        classes="generic-input bg"
                    />
                </Field>
                <Field>
                    <TextInput
                        name="addressLine2"
                        placeholder={translate('addressLine2')}
                        value={form.addressLine2}
                        onChange={handleChange}
                        classes="generic-input bg"
                    />
                </Field>
                <Field>
                    <TextInput
                        name="addressLine3"
                        placeholder={translate('addressLine3')}
                        value={form.addressLine3}
                        onChange={handleChange}
                        classes="generic-input bg"
                    />
                </Field>
                <Field required>
                    <TextInput
                        required
                        name="town"
                        placeholder={translate('town')}
                        value={form.town}
                        onChange={handleChange}
                        classes="generic-input bg"
                    />
                </Field>
                <Field required>
                    <Select
                        required
                        name="country"
                        placeholder={translate('country')}
                        value={form.country}
                        onChange={handleChange}
                        classes="generic-input bg"
                        options={countryOptions}
                        disabled
                    />
                </Field>
                <Field required>
                    <TextInput
                        required
                        name="postcode"
                        placeholder={translate('postcode')}
                        value={form.postcode}
                        onChange={handleChange}
                        classes="generic-input bg"
                        disabled
                    />
                </Field>
                <Field required>
                    <TextInput
                        required
                        name="tel1"
                        placeholder={translate('telephone1')}
                        value={form.tel1}
                        onChange={handleChange}
                        classes="generic-input bg"
                    />
                </Field>
                <Field>
                    <TextInput
                        name="tel2"
                        placeholder={translate('telephone2')}
                        value={form.tel2}
                        onChange={handleChange}
                        classes="generic-input bg"
                    />
                </Field>
            </Form>
        </ModalOuterContainer>
    );
};

export default AddCardHolderModal;
